import Modal from "@via/components/modal.tsx";
import { ModalSize } from "@via/utils/constants.tsx";
import { PipelineDraftData } from "@via/utils/interfaces.tsx";
import ImportPipelineForm from "@via/pages/pipelines/create-pipeline/import-pipeline-form.tsx";
import { type FC } from "react";

interface ImportPipelineModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  pipelineDraft?: PipelineDraftData;
}

const ImportPipelineModal: FC<ImportPipelineModalProps> = ({
  open,
  setOpen,
  pipelineDraft,
}) => {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Import New Pipeline"
      showButtons={false}
      size={ModalSize.Large}>
      <ImportPipelineForm setOpen={setOpen} pipelineDraft={pipelineDraft} />
    </Modal>
  );
};

export default ImportPipelineModal;
